var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.24976V-0.000244141H0.75C0.334375 -0.000244141 0 0.334131 0 0.749756V15.2498C0 15.6654 0.334375 15.9998 0.75 15.9998H11.25C11.6656 15.9998 12 15.6654 12 15.2498V4.99976H7.75C7.3375 4.99976 7 4.66226 7 4.24976ZM9.38906 10.8548L6.37594 13.8454C6.16813 14.0519 5.8325 14.0519 5.62469 13.8454L2.61156 10.8548C2.29437 10.5401 2.51688 9.99976 2.96312 9.99976H5V7.49976C5 7.22351 5.22375 6.99976 5.5 6.99976H6.5C6.77625 6.99976 7 7.22351 7 7.49976V9.99976H9.03687C9.48312 9.99976 9.70563 10.5401 9.38906 10.8548ZM11.7812 3.28101L8.72188 0.218506C8.58125 0.0778809 8.39062 -0.000244141 8.19063 -0.000244141H8V3.99976H12V3.80913C12 3.61226 11.9219 3.42163 11.7812 3.28101Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.a97c9fac2f496f389cc5521535402a05.svg";
export { ForwardRef as ReactComponent };